import { render, staticRenderFns } from "./ProjectFileManager.vue?vue&type=template&id=365544de"
import script from "./ProjectFileManager.vue?vue&type=script&lang=js"
export * from "./ProjectFileManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports